import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';

// Context
import { LanguageProvider } from './context/LanguageContext';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

// Pages
import BrandIntroPage from './pages/BrandIntroPage';
import ScribAIExperiencePage from './pages/ScribAIExperiencePage';
import ProductPage from './pages/ProductPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ShippingPage from './pages/ShippingPage';
import ReturnsPage from './pages/ReturnsPage';
import ContactPage from './pages/ContactPage';
import LegalNoticePage from './pages/LegalNoticePage';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Navigation />
      <main>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<BrandIntroPage />} />
          <Route path="/experience" element={<ScribAIExperiencePage />} />
          <Route path="/product" element={<ProductPage />} />
          
          {/* Legal Pages */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/legal-notice" element={<LegalNoticePage />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="bottom-center" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
